// Hook do "Pedido Minimo" (config global por tenant, afeta delivery do cardapio).

import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { bairrosApi } from "../api/bairrosApi";

export function usePedidoMinimo() {
  const [valor, setValor] = useState("");
  const [saving, setSaving] = useState(false);
  const [touched, setTouched] = useState(false);
  // false até a 1ª leitura: o campo não pode aparecer vazio ("liberado para qualquer
  // valor") antes de saber o valor gravado — o lojista acharia que perdeu a configuração.
  const [carregado, setCarregado] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await bairrosApi.getPedidoMinimo();
      const pm = Number(data?.pedido_minimo) || 0;
      // Número com ponto ("15.5"): o campo de caixa registradora mostra R$ 15,50.
      setValor(pm > 0 ? String(pm) : "");
      setTouched(false);
    } catch (e) {
      // ignora — fallback ja tratado dentro da API
    } finally {
      setCarregado(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const handleChange = (v) => {
    setValor(v);
    setTouched(true);
  };

  const salvar = useCallback(async () => {
    setSaving(true);
    try {
      const v = valor.trim() === "" ? 0 : parseFloat(String(valor).replace(",", ".")) || 0;
      await bairrosApi.setPedidoMinimo(v);
      toast.success(
        v > 0 ? `Pedido mínimo de R$ ${v.toFixed(2).replace(".", ",")} salvo` : "Pedido mínimo desativado"
      );
      setValor(v > 0 ? String(v) : "");
      setTouched(false);
    } catch (e) {
      toast.error("Erro ao salvar pedido mínimo");
    } finally {
      setSaving(false);
    }
  }, [valor]);

  return { valor, saving, touched, carregado, handleChange, salvar };
}
